(ns teamoesterreich.user-mode.navigation.bottom-bar
  (:require [reagent.core :as r]
            [reagent-material-ui.components :as mui]
            [teamoesterreich.user-mode.navigation.cookie-warning :as cookie-warning]
            [teamoesterreich.util.log :as log]
            [reagent-material-ui.icons.keyboard-arrow-left :refer [keyboard-arrow-left]]
            [reagent-material-ui.icons.home :refer [home]]
            [reagent-material-ui.icons.save :refer [save]]

            [reagent.core :as r]
            [teamoesterreich.store :as store]
            [teamoesterreich.text.get-text :as txt]
            [teamoesterreich.text.get-text :as txt]
            [teamoesterreich.user-mode.actions :as a]
            [teamoesterreich.user-mode.navigation.cookie-warning :as cookie-warning]         ;usage
            ))




(defn set-actions [& [bottom-back-fn bottom-save-fn]]
  (log/out "set bottom-nav-bar " bottom-back-fn bottom-save-fn)
  (let [!bottom-back-fn (r/cursor store/app-state [:bottom-back-fn])
        !bottom-save-fn (r/cursor store/app-state [:bottom-save-fn])]
    (reset! !bottom-back-fn bottom-back-fn)
    (reset! !bottom-save-fn bottom-save-fn)
    )


  ;(swap! store/app-state assoc :bottom-back-fn bottom-back-fn)
  ;(swap! store/app-state assoc :bottom-save-fn bottom-save-fn)
  )



(a/register-bottom-bar-back-action-set set-actions)


(defn bottom-nav-bar [!bottom-save-fn !bottom-back-fn]
  [mui/bottom-navigation

   [mui/bottom-navigation-action
    {:label   "Zurück"
     :title   "Zurück"
     :value   "back"
     :icon    (r/as-element [keyboard-arrow-left])
     :onClick (fn [_] (if @!bottom-back-fn (let [back-fn @!bottom-back-fn]
                                             (swap! store/app-state assoc :bottom-back-fn nil)
                                             (back-fn))
                                           (a/set-page-back)))
     }]

   (if (not @!bottom-save-fn)
     [mui/bottom-navigation-action
      {:label   "Home"
       :title   "Home"
       :value   "home"
       :icon    (r/as-element [home])
       :onClick (fn []
                  (a/set-no-back-page :landing))
       }]

     [mui/bottom-navigation-action
      {:label   "Speichern"
       :title   "Speichern"
       :value   "save"
       :icon    (r/as-element [save {:style {:color "#e10032"}}])
       :onClick #(@!bottom-save-fn)
       }])
   ]
  )

(defn impressum-line []
  [:div
   (txt/txt :core "footer")
   " | " [:a {:href "" :onClick #(do (a/set-page :impressum :landing) (.preventDefault %))} (txt/transl "Impressum")]
   " | " [:a {:href "" :onClick #(do (a/set-page :dsgvo :landing) (.preventDefault %))} (txt/transl "Datenschutz")]
   ]
  )

(defn bar []
  (let [!bottom-save-fn (r/cursor store/app-state [:bottom-save-fn])
        !bottom-back-fn (r/cursor store/app-state [:bottom-back-fn])
        !actual-page (r/cursor store/app-state [:site])
        show-cookie-warning? false                          ;; maybe later!! firebase.auth.Auth.Persistence.SESSION
        ]
    [mui/paper (if show-cookie-warning?
                 {:style {:position "sticky" :marginTop "calc(5% - 260px)" :height "250px" :bottom "0" :width "100vw" :overflow "hidden"}}
                 {:style {:position "sticky" :marginTop "calc(5% + 60px)" :bottom "0" :width "100vw" :overflow "hidden"}})
     (when show-cookie-warning?
       [cookie-warning/bottom-drawer-content])
     ;(log/out "###################### redraw bottom-nav-bar " @!actual-page @!bottom-save-fn)
     (when (and @!actual-page (not= @!actual-page :landing))
       (bottom-nav-bar !bottom-save-fn !bottom-back-fn))
     (impressum-line)
     ]))


